import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {RequestService} from "../../services/request/request.service";

@Component({
  selector: 'sb-detail-tooltip',
  templateUrl: './detail-tooltip.component.html',
  styleUrls: ['./detail-tooltip.component.scss'],
})
export class DetailTooltipComponent {

  @Input()
  set context(context: any) {
    this.recordId = context.recordId;
    this.recordTable = context.recordTable;
    this.isNewRecord = context.isNewRecord;
    this.record = null;
    this.getData();
  }

  recordId: string;
  recordTable: string;
  isNewRecord: boolean;

  record: any;

  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string;
  version: string;
  displayValue: string;

  constructor(private hostElement: ElementRef, private requestService: RequestService) {
  }

  async onCreated(e: any) {
    await this.getData();
  }

  async getData() {
    if (this.recordId && this.recordTable && !this.isNewRecord && !this.record ) {
      const request = this.requestService.createRequest();
      const result: any = await request
        .controller("servicely.core.System")
        .method("get")
        .data({id: this.recordId, includeSystemFields: true})
        .table(this.recordTable)
        .execute();

      this.record = result.data;

      this.createdBy = this.record.CreatedBy.displayValue;
      this.createdOn = this.record.CreatedOn.displayValue;
      this.updatedBy = this.record.UpdatedBy.displayValue;
      this.updatedOn = this.record.UpdatedOn.displayValue;
      this.version = this.record.Version.displayValue;
      this.displayValue = this.record._displayValue;
    }
  }
}
